module.exports = __webpack_public_path__ + "img/error400-cover.d8571076.png";